import { useState } from 'react';
import './code_snippets.scss'
import { __ } from '@wordpress/i18n';
import nxtds_icons from '../../dashIcon';
import Components from '../components/components';
import { nxtdash_save_data, extraOptionsSave } from '../../apicall';
const { Nexter_Range } = Components;
import ExtensionInstallPopup from '../extension_install_pop/ext_install_pop'

let extensionInstall = (nxtext_ajax_object?.dashData?.extensioninstall) ? true : false;

var nexterCustLink = nxtext_ajax_object?.dashData?.adminUrl || '';

var Theme_cstm_crds = [
    {
        key: 'code-snippets',
        name: __('Code Snippets', 'nexter-extension'),
        crd_desc: __('Add custom code snippets to your site.', 'nexter-extension'),
        popDesc: __('This admin bar tool provides insights into which code snippets and scripts are loaded on the current page, helping with debugging and optimization. It also includes a customizable code editor where you can set a fixed height in pixels or enable auto-grow to let the editor expand automatically based on the code content.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/add-code-snippets-in-wordpress/",
        cust_link: nexterCustLink + "admin.php?page=nxt_code_snippets",
        doclink: "https://nexterwp.com/docs/add-code-snippets-in-wordpress/",
        formField: { key: 'code-snippets', label: __('Code Snippets', 'nexter-extension') },
    },
];

const CodeSnippets = () => {

    const [enabledSettings, setEnabledSettings] = useState(() => {
        const extraSettings = nxtext_ajax_object?.dashData?.nxtExtra || {};
    
        // Initialize the settings object
        const defaultSettings = {
            'code-snippets': {
                switch: typeof extraSettings['code-snippets']?.switch !== 'undefined' ? !!extraSettings['code-snippets'].switch : true,
                values: {
                    adminbar : false
                }
            }
        };
    
        // Check if keys are present and merge with defaults
        if (!extraSettings['code-snippets'] || !extraSettings['code-snippets']['values']) {
            extraSettings['code-snippets'] = defaultSettings['code-snippets'];
        }else if(extraSettings['code-snippets'] && extraSettings['code-snippets']['switch'] === undefined){
            extraSettings['code-snippets']['switch'] = defaultSettings['code-snippets']['switch']
        }

        return {
            ...extraSettings,
        };
    });

    const [extType, setExtType] = useState('');
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isPopupExtensionInstall, setIsPopupExtensionInstall] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupInputValue, setPopupInputValue] = useState({});

    const handleOpenPopup = (data) => {
        setExtType(data.key)
        setPopupData(data);
        const initialPopupInputValue = {};
        Object.keys(data.formField).forEach(key => {
            initialPopupInputValue[key] = enabledSettings[key] || '';
        });
        setPopupInputValue(initialPopupInputValue);
        setIsPopupVisible(true);
    };

    const handleClosePopup = () => {
        setIsPopupVisible(false);
        setPopupData(null);
        setPopupInputValue({});
    };

    const handleCheckboxChange = (e, key, opt) => {
        const updateSwitch = { ...enabledSettings }
        // Ensure the key exists with proper structure
        if (!updateSwitch[key]) {
            updateSwitch[key] = { switch: false, values: [] };
        }
        updateSwitch[key]['switch'] = e.target.checked
        setEnabledSettings(updateSwitch)
        extraOptionsSave(e, key, opt)
    };

    const handlePopupSave = (e, f) => {
        let popWrap = e.target.closest('.nxtext_settings_popup');
        let cardWrap = popWrap.querySelector('.nxtext_field_card_cover');
    
        let getID = cardWrap.getAttribute('id'); 

        const formData = new FormData();
        formData.append('action', 'nexter_ext_save_data');
        if(getID == 'code-snippets'){
            formData.append('editoropt', JSON.stringify(enabledSettings[getID].values)); 
        }
        formData.append('extension_type', getID);
        formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);

        nxtdash_save_data(e, formData)
    };
   
    const tooltipSVG = <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>

    return (
        <>
            <div className='nxtext_theme_ctm_inn_main nxtext_main_container'>
                <div className='nxtext_section_heading_cover'>
                    <h3 className='nxtext_primary_heading'>{__('Code Snippets', 'nexter-extension')}</h3>
                </div>
                <div className='nxtext_theme_cstm_crds_cover'>
                    {Theme_cstm_crds.map((item) => (
                        <div className='nxtext_field_card' key={item.name}>
                            <div className='nxtext_card_top_detail'>
                                <div className='nxtext_field_card_h_strip'>
                                    <div className='nxtext_excrd_h_cover'>
                                        <h4 className='nxtext_secondary_heading'>{item.name}</h4>
                                        <div className='nxtext_tooltip'>{tooltipSVG}
                                            <span className="nxtext_tooltiptext">{item.crd_desc}</span>
                                        </div>
                                    </div>
                                    <div className='nxtext-extra-tgl-wrap'>
                                        { (extensionInstall && item.cust_link && enabledSettings['code-snippets']?.switch) &&
                                            <div className='nxtext_tgl_with_setting'>
                                                <a className="nxtext_code_snippets_link" href={item.cust_link} target='_blank' style={{display: 'flex'}}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19 19" fill="none"><path d="M12.6667 8.77778V13.4444C12.6667 13.857 12.5028 14.2527 12.2111 14.5444C11.9193 14.8361 11.5237 15 11.1111 15H2.55556C2.143 15 1.74733 14.8361 1.45561 14.5444C1.16389 14.2527 1 13.857 1 13.4444V4.88889C1 4.47633 1.16389 4.08067 1.45561 3.78894C1.74733 3.49722 2.143 3.33333 2.55556 3.33333H7.22222M10.3333 1H15M15 1V5.66667M15 1L6.44482 9.55556" stroke="#1A1A1A" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                </a>
                                            </div>
                                        }
                                        {/* <button className={'nxtext_ex_btn' + (extensionInstall && enabledSettings['code-snippets']?.switch ? ' enabled' : '')} onClick={() => {extensionInstall ? handleOpenPopup(item) : setIsPopupExtensionInstall(prev => !prev)}} disabled={!enabledSettings['code-snippets']?.switch}>{nxtds_icons.setting}</button> */}
                                        <div className="nxtext_block_tgl_btn_cover">
                                            <input className="nxtext_toggle_btn" id={"nxt_code_snippets_toggle"} checked={(extensionInstall &&enabledSettings['code-snippets']?.switch) ? true : false} type="checkbox" onChange={(e) => {extensionInstall && handleCheckboxChange(e, 'code-snippets', 'extra')}}  onClick={() => { if (!extensionInstall) { setIsPopupExtensionInstall(prev => !prev)} } }  />
                                            <label className={"nxtext_switch_label"+(!extensionInstall ? ' nxt-pro-lock-toggle' : '')} htmlFor={"nxt_code_snippets_toggle"}>
                                                <span className="nxtext_switch_button"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                {item.read_link && !(nxtext_ajax_object?.dashData?.whiteLabel?.nxt_help_link == 'on') &&
                                    <div className='nxtext_links_cover'>
                                        <a target="_blank" rel="noopener noreferrer" href={item.read_link || '#'} className='nxtext_tertiary_btn nxtext_paragraph'>{__('Read Docs', 'nexter-extension')}</a>
                                    </div>
                                }
                            </div>
                        </div>
                    ))}
                </div>
                {/* {isPopupVisible &&
                <div>
                    <>
                        <div className='nxtext_overlay' onClick={handleClosePopup}></div>
                        <div className={`nxtext_settings_popup ${extType}-popup`}>
                        <svg className='nxtext_close_icon' draggable={false} onClick={handleClosePopup} xmlns="http://www.w3.org/2000/svg" width="36" height="17" fill="none" viewBox="0 0 36 17"><path fill="#414B5A" d="M22.2 4.30665c-.26-.26-.68-.26-.94 0L18 7.55998l-3.26-3.26c-.26-.26-.68-.26-.94 0-.26.26-.26.68 0 .94l3.26 3.26L13.8 11.76c-.26.26-.26.68 0 .94.26.26.68.26.94 0L18 9.43998 21.26 12.7c.26.26.68.26.94 0 .26-.26.26-.68 0-.94l-3.26-3.26002 3.26-3.26c.2533-.25333.2533-.68 0-.93333Z"/></svg>

                            <div className='nxtext_popup_heading'>
                                <h3 className='nxtext_primary_heading'>{popupData.name}</h3>
                                <p className='nxtext_paragrph' dangerouslySetInnerHTML={{ __html: popupData.popDesc }}></p>

                            </div>
                            <div className='nxtext_popup_inner_main_co'>
                                {Object.keys(popupData.formField).map((key) => {
                                    const field = popupData.formField[key];
                                    if(key == 'label'){
                                        return
                                    }
                                    return (

                                        <div className='nxtext_field_card_cover' key={key} id={field}>
                                            <div className='nxtext_crd_head_strip'>
                                                <label htmlFor={key} className='nxtext_secondary_heading'>{field.label}</label>
                                            </div>
                                            <div className='nxtext_perfmnce_crds_maincover'>
                                                {field === 'code-snippets' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        
                                                        <div className='nxtext_strip_tgl_cover nxtext_full_strip_tgl'>
                                                            <div className='nxtext_strip_tgl_h'>
                                                                <label className='nxtext_paragrph' htmlFor={"adminbartoggle"}>{"Admin Bar Info"}</label>
                                                            </div>
                                                            <div className='nxtext_tgl_with_setting'>
                                                                <div className="nxtext_block_tgl_btn_cover">
                                                                    <input className="nxtext_toggle_btn" id={"adminbartoggle"} type="checkbox" checked={enabledSettings['code-snippets']?.values?.['adminbar'] || false} onChange={(e)=>{
                                                                        const { id, checked } = e.target;
                                                                        const updatedSettings = { ...enabledSettings };
                                                                        updatedSettings['code-snippets'].values['adminbar'] = (checked) ? checked : false;
                                                                        setEnabledSettings(updatedSettings);
                                                                    }}/>
                                                                    <label className="nxtext_switch_label" htmlFor={"adminbartoggle"}>
                                                                        <span className="nxtext_switch_button"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className='nxtext_popup_bottom'>
                                {popupData.doclink &&
                                    <a className='nxtext_tertiary_btn' target="_blank" rel="noopener noreferrer" href={popupData.doclink}>{__('Read How it Works', 'nexter-extension')}</a>
                                }
                                <button className="nxtext_blue_common_btn" onClick={handlePopupSave}>{__('Save', 'nexter-extension')}</button>
                            </div>
                        </div>
                    </>
                </div>
                } */}
            {isPopupExtensionInstall &&
                <ExtensionInstallPopup isPopupExtensionInstall={isPopupExtensionInstall} setIsPopupExtensionInstall={setIsPopupExtensionInstall} />
            }
            </div>
        </>

    )
}


export default CodeSnippets;